import { createApiAction, showNotification } from "services/api";
import {
  StartAction,
  SuccessAction,
  FailureAction,
} from "services/api/redux/types";


/*--------------------------------------------------------------------
  TRANSLATIONS
-------------------------------------------------------------------- */

export enum TranslationActionTypes {
  FETCH_TRANSLATIONS_START = "settings/fetch_translations_start",
  FETCH_TRANSLATIONS_SUCCESS = "settings/fetch_translations_success",
  FETCH_TRANSLATIONS_FAILURE = "settings/fetch_translations_failure",
  DELETE_TRANSLATIONS_START = "settings/delete_translations_start",
  DELETE_TRANSLATIONS_SUCCESS = "settings/delete_translations_success",
  DELETE_TRANSLATIONS_FAILURE = "settings/delete_translations_failure",
}

/*--------------------------------------------------------------------------------
    SEARCH
  ------------------------------------------------------------------------------------*/

const fetchTranslationsActionStart = (): StartAction => ({
  type: TranslationActionTypes.FETCH_TRANSLATIONS_START,
  payload: null,
});

const fetchTranslationsActionSuccess = (
  payload: any
): SuccessAction => {
  return {
    type: TranslationActionTypes.FETCH_TRANSLATIONS_SUCCESS,
    payload,
  };
};

const fetchTranslationsActionFailure = (
  error: string
): FailureAction => ({
  type: TranslationActionTypes.FETCH_TRANSLATIONS_FAILURE,
  payload: { error },
});

export const fetchTranslations = () =>
  createApiAction(
    {
      path: "/v1/translations?translationLanguageId=hr&pagesize=100000",
      method: "GET",
    },
    fetchTranslationsActionStart,
    fetchTranslationsActionSuccess,
    fetchTranslationsActionFailure
  );

/*--------------------------------------------------------------------------------
    DELETE
  ------------------------------------------------------------------------------------*/

const deleteTranslationsActionStart = (): StartAction => {
  return {
    type: TranslationActionTypes.DELETE_TRANSLATIONS_START,
    payload: null,
  };
};

const deleteTranslationsActionSuccess = (
  payload: any
): SuccessAction => {
  showNotification("Prijevod je uspješno obrisan", {
    variant: "success",
  });
  return {
    type: TranslationActionTypes.DELETE_TRANSLATIONS_SUCCESS,
    payload,
  };
};

const deleteTranslationsActionFailure = (error: any): FailureAction => {
  showNotification(error.message, { variant: "error" });
  return {
    type: TranslationActionTypes.DELETE_TRANSLATIONS_FAILURE,
    payload: { error },
  };
};

export const deleteTranslation = (translationId: string) =>
  createApiAction(
    {
      path: `/v1/translations/${translationId}`,
      method: "DELETE",
      additionalData: { translationId: translationId },
    },
    deleteTranslationsActionStart,
    deleteTranslationsActionSuccess,
    deleteTranslationsActionFailure
  );
